// extracted by mini-css-extract-plugin
export default {"cls1":"kBzqLgbTiCP5jcVSLTRl","cls2":"iWC6VxKRk5sjOgczIf7U kBzqLgbTiCP5jcVSLTRl"};